"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayoutStylesContextController = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PageLayoutStylesContext_1 = require("../pageLayoutStylesContext/PageLayoutStylesContext");
const PageLayoutStylesContextController = ({ children, pageLayoutStyles, }) => {
    return ((0, jsx_runtime_1.jsx)(PageLayoutStylesContext_1.PageLayoutStylesContext.Provider, { value: { ...pageLayoutStyles }, children: children }));
};
exports.PageLayoutStylesContextController = PageLayoutStylesContextController;
